import React from 'react';
import PropTypes from 'prop-types'

/**
 * Componente de utilería encargado de mostrar un Modal en el cual es
 * posible insertar cualquier otro elemento como componentes hijos del mismo.
 */

export default class Modal extends React.Component{

    // Función que se efectuará cuando el usuario presione alguna tecla
    escFunction = (event) => {
        if(event.keyCode === 27) {
          this.props.cancel();
        }
      }

      // Se registra un escuchador en caso de que el usuario presione alguna tecla
      componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
      }
      // Se elimina el escuchador.
      componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }

    render(){
        let width = this.props.width;
        return(
            <div className={(this.props.showModal ? "modal is-active has-overflow" : "modal") + (this.props.customClass != "" ? " " + this.props.customClass : "")} >
                <div className="modal-background" onClick={() => this.props.cancel()}/>
                <div className="modal-card" style={{ width: width ? width : ""}}>
                    <header className="modal-card-head">
                    <p className="modal-card-title">{this.props.modalTitle}</p>
                    <button onClick={() => this.props.cancel()} className="delete" aria-label="close"></button>
                    </header>
                    <section expand={this.props.espand} className="modal-card-body" style={{borderBottomLeftRadius: this.props.footer ? "0px" : "6px", borderBottomRightRadius: this.props.footer ? "0px" : "6px"}}>
                        {/*
                            En esta parte se dibujan todos los elementos o componentes que se
                            hayan puesto como hijos del Modal que vienen en la prop children
                        */}
                        {this.props.children}
                    </section>
                    {
                        this.props.footer && 
                        <footer className="modal-card-foot">
                            {/* <button className="button is-success">Save changes</button>
                            <button className="button">Cancel</button> */}
                            {this.props.footerButtons}
                        </footer>
                    }
                </div>
            </div>
        )
    }
}

Modal.propTypes = {
    footer: PropTypes.bool,
    customClass: PropTypes.string
}

Modal.defaultProps = {
    footer: false,
    customClass: ""
}